import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { learnMore } from '../pdpMessages';
import { benefitVetted, benefitProtection, benefitDelivery } from './Benefits/Benefits';

// styles
import styles from './PdpRespBuyerAssuranceBox.scss';

// helpers
import classnames from 'classnames';
import tracking from 'dibs-tracking';

// constants
const LINK_BUYER = '/about/promise/';
const LINK_TRADE = '/info/trade/benefits/';

const header = isVerifiedTrade => (
    <FormattedMessage
        values={{ isVerifiedTrade }}
        id="PdpRespBuyerAssuranceBox.header"
        defaultMessage={`{isVerifiedTrade, select,
            true {Why Designers Shop on 1stdibs}
            other {Why Shop on 1stdibs?}
        }`}
    />
);

const trackLearnMore = () =>
    tracking.trackEvent({
        action: 'buyer protection',
        label: 'clicked',
        category: 'product',
        value: 0,
    });

export function PdpRespBuyerAssuranceBox({ user }) {
    const isVerifiedTrade = !!(user && user.isVerifiedTrade);
    const learnMoreLink = isVerifiedTrade ? LINK_TRADE : LINK_BUYER;

    const benefitsClass = classnames(styles.benefits, 'rowFlex', {
        [styles.isTrade]: isVerifiedTrade,
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <h2 className={styles.header}>{header(isVerifiedTrade)}</h2>
                <p className={styles.learnMore}>
                    <a href={learnMoreLink} onClick={trackLearnMore}>
                        {learnMore}
                    </a>
                </p>
                {/* Benefits */}
                <div className={benefitsClass}>
                    <div className="colXs4">{benefitVetted}</div>
                    <div className="colXs4">{benefitProtection}</div>
                    <div className="colXs4">{benefitDelivery}</div>
                </div>
            </div>
        </div>
    );
}

PdpRespBuyerAssuranceBox.propTypes = {
    user: PropTypes.object,
};

export default createFragmentContainer(PdpRespBuyerAssuranceBox, {
    user: graphql`
        fragment PdpRespBuyerAssuranceBox_user on User {
            isVerifiedTrade
        }
    `,
});
